import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

function Vi(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="createspreadsheet">
                1.&nbsp;<span className="material-symbols-outlined">note_add</span>&nbsp;{translate('createspreadsheet')}
            </Typography>
            <p><strong>{translate('createspreadsheet')}</strong> là một hành tạo Google Spreadsheet.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này.</td>
                                <td>$newSpreadsheet_1</td>
                            </tr>
                            <tr>
                                <td>{translate('providerid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là <strong>Provider ID</strong> của kết nối Google Spreadsheets được sử dụng để xác định tài khoản Google Spreadsheets (xem <Box component={Link} to="/control-center/documentation/connections/spreadsheet">tại đây</Box> để biết tạo kết nối).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('title')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là tiêu đề Spreadsheets.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$newSpreadsheet_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('providerid')}</span>
                            <div>spreadsheets-1a2b3c4d5e6g7h</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('title')}</span>
                            <div>New Spreadsheet</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>https://docs.google.com/spreadsheets/d/1o99OEiRin5H8JZyomfn7UHaNFbE1fiPUQ1_PpWDEwv8/edit?ouid=0123456789</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="getspreadsheet">
                2.&nbsp;<span className="material-symbols-outlined">grid_on</span>&nbsp;{translate('getspreadsheet')}
            </Typography>
            <p><strong>{translate('getspreadsheet')}</strong> là một hành động truy xuất một đối tượng Google Spreadsheets.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này.</td>
                                <td>$spreadsheet_1</td>
                            </tr>
                            <tr>
                                <td>{translate('providerid')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là <strong>Provider ID</strong> của kết nối Google Spreadsheets được sử dụng để xác định tài khoản Google Spreadsheets (xem <Box component={Link} to="/control-center/documentation/connections/spreadsheet">tại đây</Box> để biết tạo kết nối).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('spreadsheetid')}<span>*</span></td>
                                <td>
                                <ParametersTypeValue type="text" />
                                </td>
                                <td>Là ID hoặc URL của tệp bạn muốn truy xuất.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('sheetname')}<span>*</span></td>
                                <td>
                                <ParametersTypeValue type="text" />
                                </td>
                                <td>Là tên bảng tính trong Spreadsheets.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="object" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$spreadsheet_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('providerid')}</span>
                            <div>spreadsheets-1a2b3c4d5e6g7h</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('spreadsheetid')}</span>
                            <div>1o99OEiRin5H8JZyomfn7UHaNFbE1fiPUQ1_PpWDEwv8</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('sheetname')}</span>
                            <div>Sheet 1</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        {
                                            "spreadsheetId": "1o99OEiRin5H8JZyomfn7UHaNFbE1fiPUQ1_PpWDEwv8",
                                            "properties": {
                                                "title": "New Spreadsheet",
                                                "locale": "ja_JP",
                                                "autoRecalc": "ON_CHANGE",
                                                "time": "Etc/GMT",
                                                "defaultFormat": {
                                                "backgroundColor": {
                                                    "red": 1,
                                                    "green": 1,
                                                    "blue": 1
                                                },
                                                "padding": {
                                                    "top": 2,
                                                    "right": 3,
                                                    "bottom": 2,
                                                    "left": 3
                                                },
                                                "verticalAlignment": "BOTTOM",
                                                "wrapStrategy": "OVERFLOW_CELL",
                                                "textFormat": {
                                                    "foregroundColor": {},
                                                    "fontFamily": "arial, sans, sans-serif ",
                                                    "fontSize": 10,
                                                    "bold": false,
                                                    "italic": false,
                                                    "strikethrough": false,
                                                    "underline": false,
                                                    "foregroundColorStyle": {
                                                    "rgbColor": {}
                                                    }
                                                },
                                                "backgroundColorStyle": {
                                                    "rgbColor": {
                                                    "red": 1,
                                                    "green": 1,
                                                    "blue": 1
                                                    }
                                                }
                                                },
                                                "spreadsheetTheme": {
                                                "primaryFontFamily": "Arial",
                                                "themeColors": [
                                                    {
                                                    "colorType": "TEXT",
                                                    "color": {
                                                        "rgbColor": {}
                                                    }
                                                    },
                                                    {
                                                    "colorType": "BACKGROUND",
                                                    "color": {
                                                        "rgbColor": {
                                                        "red": 1,
                                                        "green": 1,
                                                        " blue ": 1
                                                        }
                                                    }
                                                    },
                                                    {
                                                    "colorType": "ACCENT1",
                                                    "color": {
                                                        "rgbColor": {
                                                        "red": 0.25882354,
                                                        "green": 0.52156866,
                                                        "blue": 0.95686275
                                                        }
                                                    }
                                                    },
                                                    {
                                                    "colorType": "ACCENT2",
                                                    "color": {
                                                        "rgbColor": {
                                                        "red": 0.91764706,
                                                        "green": 0.2627451,
                                                        "blue": 0.20784314
                                                        }
                                                    }
                                                    },
                                                    {
                                                    "colorType": "ACCENT3",
                                                    "color": {
                                                        "rgbColor": {
                                                        "red": 0.9843137,
                                                        "green": 0.7372549,
                                                        "blue": 0.015686275
                                                        }
                                                    }
                                                    },
                                                    {
                                                    "colorType": "ACCENT4",
                                                    "color": {
                                                        "rgbColor": {
                                                        "red": 0.20392157,
                                                        "green": 0.65882355,
                                                        "blue": 0.3254902
                                                        }
                                                    }
                                                    },
                                                    {
                                                    "colorType": "ACCENT5",
                                                    "color": {
                                                        "rgbColor": {
                                                        "red": 1,
                                                        "green": 0.42745098,
                                                        "blue": 0.003921569
                                                        }
                                                    }
                                                    },
                                                    {
                                                    "colorType": "ACCENT6",
                                                    "color": {
                                                        "rgbColor": {
                                                        "red": 0.27450982,
                                                        "green": 0.7411765,
                                                        "blue": 0.7764706
                                                        }
                                                    }
                                                    },
                                                    {
                                                    "colorType": "LINK",
                                                    "color": {
                                                        "rgbColor": {
                                                        "red": 0.06666667,
                                                        "green": 0.33333334,
                                                        "blue": 0.8
                                                        }
                                                    }
                                                    }
                                                ]
                                                }
                                            },
                                            "sheets": [
                                                {
                                                "properties": {
                                                    "sheetId": 0,
                                                    "title": "sheet 1",
                                                    "index": 0,
                                                    "sheetType": "GRID",
                                                    " gridProperties ": {
                                                    "rowCount": 1000,
                                                    "columnCount": 26
                                                    }
                                                }
                                                }
                                            ],
                                            " spreadsheetUrl ": " https://docs.google.com/spreadsheets/d/1o99OEiRin5H8JZyomfn7UHaNFbE1fiPUQ1_PpWDEwv8/edit?ouid=0123456789",
                                            "providerID": "spreadsheets-1a2b3c4d5e6g7h"
                                            }, null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="getvalues">
                3.&nbsp;<span className="material-symbols-outlined">window</span>&nbsp;{translate('getvalues')}
            </Typography>
            <p><strong>{translate('getvalues')}</strong> là một hành động lấy giá trị của các ô trong Google Spreadsheet.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này.</td>
                                <td>$spreadsheetValues_1</td>
                            </tr>
                            <tr>
                                <td>{translate('spreadsheet')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="object" />
                                </td>
                                <td>Là kết quả của <strong>{translate('getspreadsheet')}</strong>.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('range')}<span>*</span></td>
                                <td>
                                <ParametersTypeValue type="text" />
                                </td>
                                <td>Là phạm vi các ô trong trang tính bạn muốn lấy giá trị.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$spreadsheetValues_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('spreadsheet')}</span>
                            <div>$spreadsheet_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('range')}</span>
                            <div>A1:B3</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            [
                                                "A1",
                                                "B1"
                                            ],
                                            [
                                                "A2",
                                                "B2"
                                            ],
                                            [
                                                "A3",
                                                "B3"
                                            ]
                                        ], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="updatevalues">
                4.&nbsp;<span className="material-symbols-outlined">app_registration</span>&nbsp;{translate('updatevalues')}
            </Typography>
            <p><strong>{translate('updatevalues')}</strong> là một hành động cập nhật giá trị của các ô trong Google Spreadsheet.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('spreadsheet')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="object" />
                                </td>
                                <td>Là kết quả của <strong>{translate('getspreadsheet')}</strong>.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('range')}<span>*</span></td>
                                <td>
                                <ParametersTypeValue type="text" />
                                </td>
                                <td>Là phạm vi các ô trong trang tính bạn muốn cập nhật giá trị.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('value')}<span>*</span></td>
                                <td>
                                <ParametersTypeValue type="array" />
                                </td>
                                <td>Là giá trị dùng để cập nhật.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('spreadsheet')}</span>
                            <div>$spreadsheet_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('range')}</span>
                            <div>A1:B3</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('value')}</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            [
                                                "A1",
                                                "B1"
                                            ],
                                            [
                                                "A2",
                                                "B2"
                                            ],
                                            [
                                                "A3",
                                                "B3"
                                            ]
                                        ], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="appendvalues">
                5.&nbsp;<span className="material-symbols-outlined">apps</span>&nbsp;{translate('appendvalues')}
            </Typography>
            <p><strong>{translate('appendvalues')}</strong> là hành động nối thêm các giá trị ngay sau bảng mà phạm vi đã chỉ định chứa trong Google Spreadsheet.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('spreadsheet')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="object" />
                                </td>
                                <td>Là kết quả của <strong>{translate('getspreadsheet')}</strong>.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('range')}<span>*</span></td>
                                <td>
                                <ParametersTypeValue type="text" />
                                </td>
                                <td>Là phạm vi bảng được chỉ định.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('value')}<span>*</span></td>
                                <td>
                                <ParametersTypeValue type="array" />
                                </td>
                                <td>Là giá trị dùng để thêm vào.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('spreadsheet')}</span>
                            <div>$spreadsheet_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('range')}</span>
                            <div>A3:B4</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('value')}</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        [["A3", "B3"], ["A4", "B4"]], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="clearvalues">
                6.&nbsp;<span className="material-symbols-outlined">backspace</span>&nbsp;{translate('clearvalues')}
            </Typography>
            <p><strong>{translate('clearvalues')}</strong> là hành động xóa các giá trị trong phạm vi được chỉ định trong Google Spreadsheet.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('spreadsheet')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="object" />
                                </td>
                                <td>Là kết quả của <strong>{translate('getspreadsheet')}</strong>.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('range')}<span>*</span></td>
                                <td>
                                <ParametersTypeValue type="text" />
                                </td>
                                <td>Là phạm vi bảng được chỉ định.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('spreadsheet')}</span>
                            <div>$spreadsheet_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('range')}</span>
                            <div>A3:B4</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="duplicatesheet">
                7.&nbsp;<span className="material-symbols-outlined">table_view</span>&nbsp;{translate('duplicatesheet')}
            </Typography>
            <p><strong>{translate('duplicatesheet')}</strong> là hành động sao chép một trang tính trong Google Spreadsheet.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này.</td>
                                <td>$duplicateSheet_1</td>
                            </tr>
                            <tr>
                                <td>{translate('spreadsheet')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="object" />
                                </td>
                                <td>Là kết quả của <strong>{translate('getspreadsheet')}</strong>.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('sheetname')}<span>*</span></td>
                                <td>
                                <ParametersTypeValue type="text" />
                                </td>
                                <td>Là tên trang tính sao chép.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('spreadsheetdestination')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là kết quả của <strong>{translate('getspreadsheet')}</strong>.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('sheetnamedestination')}<span>*</span></td>
                                <td>
                                <ParametersTypeValue type="text" />
                                </td>
                                <td>Là tên trang tính mới.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="object" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$duplicateSheet_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('spreadsheet')}</span>
                            <div>$spreadsheet_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('sheetname')}</span>
                            <div>Sheet 1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('spreadsheetdestination')}</span>
                            <div>$spreadsheet_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('sheetnamedestination')}</span>
                            <div>Sheet 2</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        {
                                            "sheetId": 180652978,
                                            "title": "Sheet 2",
                                            "index": 1,
                                            "sheetType": "GRID",
                                            "gridProperties": {
                                                "rowCount": 1000,
                                                "columnCount": 26
                                            }
                                        }, null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="downloadsheets">
                8.&nbsp;<span className="material-symbols-outlined">download_for_offline</span>&nbsp;{translate('downloadsheets')}
            </Typography>
            <p><strong>{translate('downloadsheets')}</strong> là hành động tải xuống một bảng tính trong Google Spreadsheet.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này.</td>
                                <td>$downloadSheets_1</td>
                            </tr>
                            <tr>
                                <td>{translate('spreadsheet')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="object" />
                                </td>
                                <td>Là kết quả của <strong>{translate('getspreadsheet')}</strong>.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('sheetname')}<span>*</span></td>
                                <td>
                                <ParametersTypeValue type="text" />
                                </td>
                                <td>Là tên trang tính muốn tải xuống (Nếu để trống sẽ tải xuống tất cả các trang tính).</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('extension')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là định dạng tệp tải xuống.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$downloadSheets_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('spreadsheet')}</span>
                            <div>$spreadsheet_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('sheetname')}</span>
                            <div>Sheet 1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('extension')}</span>
                            <div>xlsx</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>/tmp/downloads/sktwi174l9kzzqc2/20221025-003483/New Spreadsheet-Sheet 1.xlsx</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="appendsheet">
                9.&nbsp;<span className="material-symbols-outlined">sheets_rtl</span>&nbsp;{translate('appendsheet')}
            </Typography>
            <p><strong>{translate('appendsheet')}</strong> là hành động thêm một trang tính mới trong Google Spreadsheet.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('spreadsheet')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="object" />
                                </td>
                                <td>Là kết quả của <strong>{translate('getspreadsheet')}</strong>.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('sheetname')}<span>*</span></td>
                                <td>
                                <ParametersTypeValue type="text" />
                                </td>
                                <td>Là tên trang tính muốn thêm vào.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('spreadsheet')}</span>
                            <div>$spreadsheet_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('sheetname')}</span>
                            <div>Sheet 3</div>
                        </div>
                    </div>
                </li>
            </ul>
        </Box>
    );
}
export default withTranslate(Vi);